<template>
  <div class="banner-ct">
    <div class="paragraph-ct">
      <p class="top-paragraph">
        {{ $t('Gamification_Talk_To_Sales_Banner_Solve_Your_Challenges') }}
      </p>
      <p class="bottom-paragraph">
        {{ $t('Gamification_Talk_To_Sales_Banner_Make_The_First_Step') }}
      </p>
    </div>
    <div>
      <el-button @click="requestDemo()" type="primary">
        {{ $t('Gamification_Talk_To_Sales_Banner_Book_A_Demo_Btn') }}
        <i class="el-icon-arrow-right el-icon-right" />
      </el-button>
    </div>
  </div>
</template>

<script>
import RestApi from '@/core/services/RestApi'
import { customConfirm } from '@/core/helpers'
import { ProductRequestTypesEnum } from '@/common/enum/ProductRequestTypesEnum'

export default {
  name: 'GamificationBookADemoBanner',
  methods: {
    requestDemo() {
      customConfirm(
        this.$t('Gamification_Book_A_Demo_Interested_In_Gamification_Title'),
        this.$t(
          'Gamification_Book_A_Demo_Interested_In_Gamification_Description'
        ),
        this.$t(
          'Gamification_Book_A_Demo_Interested_In_Gamification_Send_Request'
        ),
        this.$t(
          'Gamification_Book_A_Demo_Interested_In_Gamification_Send_Request_Cancel'
        )
      )
        .then(() => {
          RestApi({
            method: 'post',
            url: `projects/${this.$route.query.project_id}/notification`,
            data: {
              productName: ProductRequestTypesEnum.GAMIFICATION
            }
          })
            .then(() => {
              this.$message({
                message: this.$t(
                  'Gamification_Book_A_Demo_Interested_In_Gamification_Request_Sent'
                ),
                type: 'success'
              })
            })
            .catch(() => {
              this.$message({
                message: this.$t(
                  'Gamification_Book_A_Demo_Interested_In_Gamification_Request_Failed'
                ),
                type: 'error'
              })
            })
        })
        .catch(() => {})
    }
  }
}
</script>

<style scoped>
.banner-ct {
  display: flex;
  color: white;
  justify-content: space-between;
  align-items: center;
  padding: 20px 65px;
  background: linear-gradient(94deg, #176ca1 -8.57%, #092e44 80.81%);
}

.paragraph-ct {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.top-paragraph {
  font-size: 18px;
  font-weight: 600;
  line-height: 30px;
}

.bottom-paragraph {
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/modules/gamification/components/games-hub-upsell/GamificationBookADemoBanner.vue